import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { VidebisButton } from '../../shared/components/videbis-button/videbis-button';
import { DebugBox } from '../../shared/components/debug-box/debug-box';
import { StringMap } from '../../shared/util/types';
import { ConfigTitle } from './config-title';
import CreditCard from '../../../img/videbis_creditcard_blue.png';
import '../styles/calibration.scss';
import { ConfigTextBottom } from './config-text-bottom';
import { isEnter } from '../../shared/util/functions';


library.add(faPlusCircle);
library.add(faMinusCircle);

interface Props {
    scaleFactor: number;
    onScaleChange: (decrease?: boolean) => void;
    onPress: () => void;
    onBack: () => void;
}

function getCreditCardDimensions(scaleFactor: number) {
    return {
        height: 5.4 * scaleFactor + 'cm',
        width: 8.56 * scaleFactor + 'cm'
    };
}

function getDebugContent(scaleFactor: number): StringMap<string> {
    return ({ 'Scale factor': scaleFactor.toFixed(2).toString() });
}

export const Calibration: React.FunctionComponent<Props> = props => {
    return (
        <section className={'calibration--wrapper limit-width'}>
            <div className={'calibration__description-section'}>
                <ConfigTitle title={'Kalibrierung'} subtitle={'1. Schritt: Größe einstellen'}/>
                <p className={'calibration__description standard-text'}>
                    Passen Sie diese Karte an die Größe Ihrer<br/>
                    Bank- oder Kreditkarte an:
                </p>
            </div>
            <div className={'calibration__card-section'}>
                <div tabIndex={0}
                     className={'card-section__icon card-section__minus'}
                     aria-label={'verkleinern'}
                     onKeyPress={evt => isEnter(evt) && props.onScaleChange(true)}
                     onClick={() => props.onScaleChange(true)}>
                    <FontAwesomeIcon icon={'minus-circle'}/>
                </div>
                <div id={'credit-card-wrapper'} className={'card-section__credit-card'}
                     style={getCreditCardDimensions(props.scaleFactor)}>
                    <img id={'credit-card'} src={CreditCard} alt={'A Credit Card'}/>
                </div>
                <div tabIndex={0}
                     className={'card-section__icon card-section__plus'}
                     aria-label={'vergrößern'}
                     onKeyPress={evt => isEnter(evt) && props.onScaleChange()}
                     onClick={() => props.onScaleChange()}>
                    <FontAwesomeIcon icon={'plus-circle'}/>
                </div>
            </div>
            <ConfigTextBottom
                textBottom={
                    'Setzen Sie Ihren Browser-Zoom auf 100% für optimale Ergebnisse.'
                }/>
            <div className={'calibration__buttons'}>
                <VidebisButton onPress={props.onBack} text={'Zurück'} bgColor={'#ffffff'} txtColor={'#0c23fb'}/>
                <VidebisButton onPress={props.onPress}/>
            </div>
            <DebugBox content={getDebugContent(props.scaleFactor)}/>
        </section>
    );
};
